import API from '@aws-amplify/api';
import { Storage } from 'aws-amplify';
import { v4 as uuidv4 } from 'uuid';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { createThumbnail } from '@/graphql/mutations';

export const createThumbnailAPI = async req => {
    let paramsWithConfigOptions = {
        query: createThumbnail,
        variables: {
            createThumbnailRequestDto: {
                ...req
            }
        }
    };

    try {
        const res = await API.graphql(paramsWithConfigOptions);
        const createdThumbnail = res?.data?.createThumbnail;
        return createdThumbnail;
    } catch (err) {
        console.log('createThumbnailAPI err: ', err);
        const { errors } = err;
        if (!Utils.isEmptyArray(errors)) {
            const errorType = errors[0]?.errorType;
            if (errorType === "Lambda:ExecutionTimeoutException") {
                // handle fake body
                return {
                    statusCode: 200,
                    body: JSON.stringify(req.fileList.map(fileStr => {
                        const file = Utils.convertJSONDataToObject(fileStr);
                        const { small, medium, large } = Utils.getThumbnailPaths(file?.s3Path);
                        return {
                            file,
                            thumbnailInfo: {
                                small: { thumbnailUri: small },
                                medium: { thumbnailUri: medium },
                                large: { thumbnailUri: large },
                            }
                        };
                    }))
                };
            }
        }
        return null;
    }
};

const createThumbnailOnAiChat = async (fileList, actionType) => {
    if (Utils.isEmptyArray(fileList)) return;
    const queryParams = {
        actionType,
        fileList: fileList.map(file => JSON.stringify(file)),
        attachBy: Constant.ATTACH_FILE.ATTACH_BY.AI_CHAT
    };
    const response = await createThumbnailAPI(queryParams);
    if (!response || Number(response.statusCode) !== 200) {
        return [];
    }

    return Utils.convertJSONDataToObject(response.body);
};

export const uploadImagesTmpOnAiChat = async (path, listImage) => {
    if (Utils.isEmptyArray(listImage)) return;
    // put image S3
	const putImageS3 = await Promise.all(
        listImage.map( async img => {
            const uploaded = await uploadImageToS3(path, img.fileData)
            return {
                id: img?.id,
                s3Path: uploaded,
            }
        })
    );

    // call createThumbnailAPI to create thumbnail
	const thumbnailData = await createThumbnailOnAiChat(
		putImageS3.filter(data => Boolean(data)),
		Constant.CREATE_THUMBNAIL_ACTION_TYPE.CREATE_THUMBNAIL_FOR_TMP_IMG,
	);
    return thumbnailData;
};

export const uploadImageToS3 = async (path, file) => {
    try {
        if (!file) throw new Error('No file provided');

		const dotIndex = file.name.lastIndexOf('.');
		const fileName = file.name.substring(0, dotIndex);
		const fileExtension = file.name.substring(dotIndex + 1);

        let cleanPath = path.startsWith("public/")
            ? path.substring("public/".length)
            : path;
		const fileKey = `${cleanPath}/uploads/${fileName}_${uuidv4()}.${fileExtension}`;

        // Upload file
        await Storage.put(fileKey, file, {
            contentType: file.type,
            level: 'public'
        });
        
		return `public/${fileKey}`;
    } catch (error) {
        console.error('Error uploading file:', error);
        return null;
    }
};
